import RestApi, { socialWelfareServiceBaseUrl } from '../config/api_config'

export default {
  computed: {
    hasDropdownLoadedSocialWelfareService () {
      return this.$store.state.SocialWelfareService.commonObj.hasDropdownLoaded
    }
  },
  watch: {
    hasDropdownLoadedSocialWelfareService: function (newValue) {
      if (!newValue) {
        this.loadDropdownSocialWelfareService()
      }
    }
  },
  created () {
    const hasDropdownLoadedSocialWelfareService = this.$store.state.SocialWelfareService.commonObj.hasDropdownLoaded
    if (!hasDropdownLoadedSocialWelfareService || window.performance) {
      this.loadDropdownSocialWelfareService()
    }
  },
  methods: {
    loadDropdownSocialWelfareService () {
      RestApi.getData(socialWelfareServiceBaseUrl, 'common-dropdowns', null).then(response => {
        if (response.success) {
          this.$store.dispatch('SocialWelfareService/mutateCommonObj', {
            hasDropdownLoaded: true,
            serviceTypeList: response.data.serviceTypeList,
            serviceNameList: response.data.serviceNameList,
            manualCategoryList: response.data.manualCategoryList,
            manualSubCategoryList: response.data.manualSubCategoryList,
            servicePointList: response.data.servicePointList
          })
          this.$store.dispatch('SocialWelfareService/localizeCommonDropdown', { value: this.$i18n.locale })
        }
      })
    }
  }
}
